// test117
(117 && 0);
